import { Configurer } from '../Core/index';
import { Zpfs_s3compat } from './Zpfs_s3compat';

/**Upload service with pseudo-S3compatible storage*/
export class Zpfs_s3compatConfigurer extends Configurer {}
